import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent implements OnInit, OnChanges {
  @Input() isRound = false;
  @Input() imageLink: string = '';
  @Output() photoChanged = new EventEmitter();
  state: any = {};
  progress = 0;

  constructor() {
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    this.state = {
      file: null,
      imagePreviewUrl:
        this.imageLink !== undefined
          ? this.imageLink
          : this.isRound
          ? 'https://aucdt.edu.gh/img/profile-picture.jpg'
          : 'https://aucdt.edu.gh/img/profile-picture.jpg',
    };
  }

  ngOnInit() {
    this.state = {
      file: null,
      imagePreviewUrl:
        this.imageLink !== undefined
          ? this.imageLink
          : this.isRound
          ? 'https://aucdt.edu.gh/img/profile-picture.jpg'
          : 'https://aucdt.edu.gh/img/profile-picture.jpg',
    };
  }

  handleImageChange(e: Event) {
    e.preventDefault();
    this.progress = 0;
    const reader = new FileReader();
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    
    if (!file) return;
    
    this.photoChanged.emit(file);
    reader.onloadend = () => {
      this.state.file = file;
      this.state.imagePreviewUrl = reader.result;
    };
    reader.readAsDataURL(file);
    this.progress = 100;
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }

  handleClick() {
    const input = document.createElement('input');
    input.type = 'file';
    input.onchange = this.handleImageChange;
    input.click();
  }

  handleRemove() {
    this.state.file = null;
    this.state.imagePreviewUrl =
      this.imageLink !== undefined
        ? this.imageLink
        : this.isRound
        ? 'https://aucdt.edu.gh/img/profile-picture.jpg'
        : 'https://aucdt.edu.gh/img/profile-picture.jpg';
  }
}